import React from 'react';
import { Button } from 'antd';
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import _ from 'lodash';

const PDFButton = ({ pdf }) => {
  const [loading, setLoading] = React.useState(false)

  const onClick = () => {
    setTimeout(() => {
      let dom = document.querySelector("iframe")?.contentWindow?.document?.getElementById("app")
      setLoading(true)
      html2canvas(dom).then(canvas => {
        const contentWidth = canvas.width / 2;
        const contentHeight = canvas.height / 2;
        const pdfWidth = contentWidth
        const pdfHeight = contentHeight // 500为底部留白
        const pageData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new jsPDF("", "pt", [pdfWidth, pdfHeight]);
        const width = pdf.internal.pageSize.width;
        const height = width * contentHeight / contentWidth
        pdf.setFontSize(14)
        pdf.addImage(pageData, "jpeg", -5, 30, width, height);
        // 导出pdf文件命名
        pdf.save('表数据详情.pdf')
        setLoading(false)
      })
    }, 1000)
  }

  if (!pdf) return null
  return <div style={{ height: 1, width: '100%' }}>
    <Button style={{ left: '95%', top: 20 }} onClick={onClick} loading={loading}>导出PDF</Button>
  </div>
}

export default PDFButton
